export default __webpack_public_path__ + "media/gallery/piper-heidsieck-3ccd90e6.jpg";